import React, { FC, useEffect, useRef, useState } from 'react';
import TitleContent from 'src/components/molecules/contentLayout/TitleContent';
import TitleContentDetail from 'src/components/molecules/contentLayout/TitleContentDetail';
import InputBox from 'src/components/atoms/input/DefInputBox';
import { addComma } from 'src/utils/common';
import IconButton from 'src/components/atoms/buttons/IconButton';
import './style.scss';

interface Props {
  data: any;
  type?: string;
}
const DeductionA: FC<Props> = ({ type = '', data }) => {
  // view type
  const [dataState, setDataState] = useState({ data: data });
  useEffect(() => {
    setDataState({ data: data });
  }, [data]);

  const inpStatus = '_read';
  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {};
  const labelStyle = { width: '450px', color: '#777', fontSize: '13px' };
  const boxStyle = { fontSize: '15px', fontWeight: '700' };

  return (
    <div className="_detail_deduction_div _active">
      {dataState.data.map((item: any, idx: number) => {
        if (item.children) {
          return (
            <div className="_row _nested" key={idx}>
              <TitleContentDetail
                id="taxation"
                label={item.label}
                value={addComma(item.value)}
                foldViewType="type2"
                foldBtn={true}
                foldBtnClickEvent={() => {}}
                contentView={false}
                content={<DeductionA type={type} data={item.children} />}
                labelStyleDef={{
                  fontSize: '13px',
                  fontWeight: '500',
                  width: '160px',
                  color: '#777',
                }}
              />
            </div>
          );
        }
        return (
          <div className={['_row', item.lv].join(' ')} key={idx}>
            <div className="_item" style={{ zIndex: 10 }}>
              <InputBox
                changeEvt={e => inpChangeEvt(e, 'name')}
                // inputRef={inpRef}
                label={item.label}
                labelPosition="left"
                value={addComma(item.value)}
                labelStyleDef={labelStyle}
                styleDef={boxStyle}
                status={inpStatus}
                inpStyleDef={{
                  textAlign: 'right',
                  fontWeight: '400',
                  fontSize: '14px',
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DeductionA;
